
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/request-course",
      function () {
        return require("private-next-pages/request-course/index.tsx");
      }
    ]);
  